export default "__VITE_ASSET__3b7fbb12__"